// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContextMenuSection__container___2i0L9{margin-bottom:3px;padding-bottom:4px}.ContextMenuSection__topBorder___3Yj4e{border-top:1px solid var(--spectrum-global-color-gray-200)}.ContextMenuSection__bottomBorder___1VTpg{border-bottom:1px solid var(--spectrum-global-color-gray-200)}.ContextMenuSection__sectionTitle___3jAZv{font-size:11px;margin-right:8px}.ContextMenuSection__sectionHeader___1H8Kc{cursor:pointer;padding:0 10px;white-space:nowrap}", ""]);
// Exports
exports.locals = {
	"container": "ContextMenuSection__container___2i0L9",
	"topBorder": "ContextMenuSection__topBorder___3Yj4e",
	"bottomBorder": "ContextMenuSection__bottomBorder___1VTpg",
	"sectionTitle": "ContextMenuSection__sectionTitle___3jAZv",
	"sectionHeader": "ContextMenuSection__sectionHeader___1H8Kc"
};
module.exports = exports;
